/*
  assets/quote-products.js
  ---------------------------------------------------------------------------
  Reglas de "Get A Quote" para las tarjetas que arma JavaScript (cuadrículas de las páginas de nivel 1 y 2,
  y las de nivel 3 cuando se aplican filtros): hub-storefront-filters.js y collection-availability-filter.js.

  ESPEJO de snippets/quote-product-check.liquid (que decide lo mismo para las tarjetas renderizadas por Liquid
  y para la ficha de producto). Si cambias una regla allá, cámbiala aquí. Diferencias inevitables: la
  Storefront API NO entrega los metacampos custom.* (familia/subtipo), así que aquí se usan los tags
  equivalentes ("Subtype: X") y el handle; las charolas "Pans" sin tag de familia solo salen por la lista de
  handles. Los handles vienen de snippets/quote-product-handles.liquid (misma lista), vía
  snippets/quote-config.liquid -> window.CS_QUOTE_CONFIG.

  API:
    CSQuote.isQuote(node)    -> true si el producto pide cotización (botón Get A Quote, badge Special Order)
    CSQuote.hidesPrice(node) -> true si además no debe mostrar precio (calentadores State Water Heaters)
  `node` = producto de la Storefront API con: handle, vendor, productType, tags, priceRange.minVariantPrice.amount,
  quoteDev / quoteBody (metacampos spec.device_type / spec.body_material, opcionales).
*/
(function () {
  'use strict';

  var CFG = window.CS_QUOTE_CONFIG || {};
  var HANDLES = {};
  (CFG.handles || []).forEach(function (h) { if (h) HANDLES[h] = true; });
  var EXCLUDED = {};
  (CFG.excluded || []).forEach(function (h) { if (h) EXCLUDED[h] = true; }); // productos que NUNCA piden cotización

  var STATE_VENDORS = { 'State Water Heaters': true };
  var MIN_PRICE = 9000; // dólares
  var CERAMICS = { 'vitreous china': 1, 'linearceram': 1, 'porcelain': 1, 'fireclay': 1, 'ceramic': 1 };
  var SUBTYPES = {
    'Tank Lids & Covers': 1, 'Toilet Tanks': 1, 'Toilet Bowls': 1, 'Two-Piece Toilets': 1, 'One-Piece Toilets': 1,
    'Wall-Hung Toilets': 1, 'Tank-Type Toilets': 1, 'Water Closets': 1, 'Water Closet Combos': 1,
    'Pressure-Assist Water Closets': 1, 'Urinals': 1, 'Urinal Combos': 1, 'Lavatories': 1, 'Lavatory': 1,
    'Pedestal Sinks': 1, 'Vessel Sinks': 1
  };
  var PLAIN_TAGS = { 'Urinals': 1, 'Elongated Bowls': 1, 'Round Bowls': 1 };
  // Porcelana con etiquetas "antiguas" simples (espejo de snippets/quote-product-check.liquid); se excluyen piezas/repuestos.
  var LEGACY_TAGS = { 'Tanks': 1, 'Toilet Tanks': 1, 'Tank Lids': 1, 'Bowls': 1, 'Round Front Bowls': 1, 'Wall Hung Bowls': 1, 'Toilet Bowls': 1, 'Waterfree Urinals': 1, 'Wall Mounted Sinks': 1, 'Drop In': 1 };
  var PART_WORDS = ['lever', 'seat', 'diaphragm', 'repair', 'kit', 'bolt', 'gasket', 'auger', 'flapper', 'valve', 'fill valve', 'handle', 'trip'];
  function titleHasPartWord(title) {
    var s = String(title || '').toLowerCase().split('with seat').join('').split('w/ seat').join('').split('w/seat').join('');
    for (var i = 0; i < PART_WORDS.length; i++) { if (s.indexOf(PART_WORDS[i]) !== -1) return true; }
    return false;
  }
  var DEV_EXCLUDE = /seat|valve|kit|flush|sensor|lever|handle|repair|part|bidet|faucet|fitting|stainless|spout/;
  var DEV_INCLUDE = /urinal|toilet|water closet|lavatory/;

  function has(tags, t) { return tags.indexOf(t) !== -1; }
  function metaValue(m) { return m && m.value ? String(m.value) : ''; }

  function stateQuote(p, tags) {
    return !!STATE_VENDORS[p.vendor] && has(tags, 'quote-only');
  }

  // Tubería rígida por datos del producto (espejo de la regla en snippets/quote-product-check.liquid; mantener iguales).
  var RP_MAT = 'pvc|cpvc|abs |galvanized|galv |black pipe|black steel|cast iron|no hub|no-hub|hubless|sdr|dwv|copper|steel pipe|iron pipe|sch 40|sch40|sch 80|sch80|schedule 40|schedule 80'.split('|');
  var RP_LEN = "'| ft|feet|x20|x 20|x10|x 10|x21|x 21".split('|');
  var RP_EXC = 'fitting|coupling|elbow| ell|tee | tee|adapter|adaptor|bushing|plug|union|nipple|valve|flange|trap|cleanout|reducer|bend|wye|saddle|cement|primer|saw|tape|sleeve|gasket|cross |strap|hanger|insulat|cutter|shear|reamer|threader|vise|stand|wrench|clamp|support|extension tube|tailpiece|termination|screen|locknut|sealant|extractor|handle|roll|groover|drain|bit|blade|pump|hose|tool|machine|kit|nut|bolt|clip|talon|hook|dies|die |cap | cap|pan|sink|faucet|toilet|shower|arm|bar|closet|head|guard|stop|hole|brush|flex|pex|poly|soft|coil|refriger|reel|braid|vinyl|rubber|nylon|corrugat|csst|connector|supply line|ice maker'.split('|');
  function isRigidPipeTitle(title) {
    var s = String(title || '').toLowerCase().split('lasco fittings').join('lasco');
    if (s.indexOf('pipe') === -1 && s.indexOf('tube') === -1 && s.indexOf('tubing') === -1) return false;
    function any(list) { for (var i = 0; i < list.length; i++) { if (s.indexOf(list[i]) !== -1) return true; } return false; }
    return any(RP_MAT) && any(RP_LEN) && !any(RP_EXC);
  }

  // Porcelana sin etiquetas, por marca + título (espejo de snippets/quote-product-check.liquid; mantener iguales).
  var PB_BR = 'american standard|ams |western pottery|porcelamex|kohler|gerber|mansfield|eljer|crane|briggs|niagara|lucerne'.split('|');
  var PB_NOUN = 'toilet|water closet|bowl|urinal|lavatory|pedestal|bidet|sink|lav |tank|basin'.split('|');
  var PB_PW = 'seat|valve|flush|lever|kit|gasket|bolt|supply|repair|handle|sensor|actuator|fill|flapper|wax|ring|trip|hinge|plate|coupling|connector|adapter|adaptor|rebuild|cartridge|diaphragm|piston|nut |washer|wrench|cleaner|brush|plunger|auger|hose|spud|battery|module|tool|clamp|hardware|mounting|carrier|bracket|rough|elbow|flange|extension|shield|filter|pad |label|cap |plug|float|stem|solenoid|regulator|vacuum|vent|trap|tube|dispenser|soap|faucet|shower|eyewash|nozzle|cleanout|paper|holder|towel|rack|cabinet|vanity|mirror|light|lid|cover|expansion|heater|pump|stainless|steel|bathtub|tub |acrylic|nipple|insulation|tape|cement|rod |guard|treatment|cushion|sponge|deodor|wedge|protector|hanger|strainer|drain|overflow|stopper|tailpiece|riser|grate|accessor|hook|bonnet|mop|catch|floor sink|service sink|filler|spout|spray|assembly|assy|box|controller|generator|board|anchor|button|override|modulator|housing|inlet|spreader|stud for'.split('|');
  var KB_IN = 'vessel sink|bathroom sink|pedestal sink|pedestal for|console sink|vitreous|porcelain|ceramic sink|ceramic bathroom|ceramic console'.split('|');
  var KB_EX = 'kitchen|faucet|accessor|towel|tub|solid surface|stainless|basket|waste|drain|strainer|rack|holder|bar sink|cartridge|shower|disc|valve|handle|lever|acrylic|glass'.split('|');
  function anyIn(s, list) { for (var i = 0; i < list.length; i++) { if (s.indexOf(list[i]) !== -1) return true; } return false; }
  function isPorcelainByTitle(p) {
    var t = String(p.title || '').toLowerCase().split('with seat').join('').split('w/ seat').join('').split('w/seat').join('').split('fauceture').join('kb');
    var vt = (String(p.vendor || '') + ' ' + String(p.title || '')).toLowerCase();
    if (t.indexOf('vitreous') !== -1) return true; // "vitreous china" en el título: porcelana sanitaria, cualquier marca
    if (anyIn(vt, PB_BR) && anyIn(t, PB_NOUN) && !anyIn(t, PB_PW)) return true;
    if (p.vendor === 'Kingston Brass' && anyIn(t, KB_IN) && !anyIn(t, KB_EX)) return true;
    return false;
  }

  function isQuote(p) {
    if (!p) return false;
    if (p.handle && EXCLUDED[p.handle]) return false;              // excepciones (snippets/quote-product-excluded.liquid)
    var tags = p.tags || [];
    if (stateQuote(p, tags)) return true;                       // 1) calentador State
    if (p.handle && HANDLES[p.handle]) return true;             // 2) lista de handles
    if (has(tags, 'get-a-quote')) return true;                  // 3) tag
    var price = p.priceRange && p.priceRange.minVariantPrice ? parseFloat(p.priceRange.minVariantPrice.amount) : 0;
    if (price >= MIN_PRICE) return true;                        // 4) $9,000 o más, cualquier marca
    if (p.vendor === 'Spartan Tool' && p.productType === 'Sewer Jetters') return true; // 5) jetters

    // 6) frágiles / muy largos
    var body = metaValue(p.quoteBody).toLowerCase();
    if (body && CERAMICS[body]) return true;
    var dev = metaValue(p.quoteDev).toLowerCase();
    if (dev && DEV_INCLUDE.test(dev) && !DEV_EXCLUDE.test(dev)) return true;
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i];
      if (t.indexOf('Subtype: ') === 0 && SUBTYPES[t.slice(9)]) return true;
      if (!titleHasPartWord(p.title) && (PLAIN_TAGS[t] || LEGACY_TAGS[t])) return true;
    }
    if (has(tags, 'Pans') && has(tags, 'Family: Water Heaters')) return true;
    if (isRigidPipeTitle(p.title)) return true;
    if (isPorcelainByTitle(p)) return true;                      // porcelana sin etiquetas (marca + título)                  // tubería rígida por datos (no por handle)
    if (has(tags, 'Stock Pipe')) return true; // tubería rígida; el PEX y demás flexibles NO
    if (p.productType === 'Copper Pipe' && !/soft|coil|refrigeration/i.test(p.title || '')) return true; // cobre rígido; el blando en rollo es flexible
    return false;
  }

  // "state" = marca State Water Heaters y el producto pide cotización (por tag o por la lista): sin precio.
  function hidesPrice(p) {
    return isQuote(p); // A pedido: ningún producto Get A Quote muestra precio, de cualquier marca
  }

  window.CSQuote = { isQuote: isQuote, hidesPrice: hidesPrice };
})();
